import Vue from 'vue'
import './plugins/vuetify'
import Nl2br from 'vue-nl2br'
import App from './App.vue'
import store from './store'
import router from './router'
import DataSetManager from './classes/DataSetManager';

Vue.component('nl2br', Nl2br);
Vue.config.productionTip = false

Vue.directive('statemachine', {
	bind: function (el, binding) {
		binding.value.bind(el);
	},
	unbind: function(el, binding) {
		binding.value.unbind();
	},
})
store.commit('initState');
store.commit('getAccessToken');
store.commit('getRefreshToken');
store.commit('setDataSetManager', new DataSetManager(store));

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
